jQuery(document).ready(function ($) {
	$(".header-menu-btn").on("click", function () {
		// $(this).toggleClass("active");
		$(".header-mobile-menu").toggleClass("active");
	});
	$(".header-mobile-menu__close").on("click", function () {
		// $(this).toggleClass("active");
		$(".header-mobile-menu").toggleClass("active");
	});

	$(".mobile-menu__item a span").on("click", function (e) {
		e.preventDefault();
		$(this).parent().toggleClass("active");
		$(this).parent().next().slideToggle();
	});

	$(".mobile-menu").niceScroll();


	$(document).on('scroll', function() {
		var y = $(this).scrollTop();
		if (y > 300) {
			$('.to-top').addClass('active');
		} else if (y > 200) {
			$('.to-top').removeClass('active');
		}
	});

	$('.to-top').on('click', function(e) {
		e.preventDefault();
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	});

	// droplist
	$(".dropdown-item__title").on("click", function () {
		$(this).parent().toggleClass("active");
		$(this).next().slideToggle(300);
	});

	function setMarginToFirstSection() {
		const topnav = $(".top-nav");

		if ($(window).width() > 1200) {
			const topnavHeight = topnav.innerHeight();
			const breadcrumbs = $(".breadcrumbs");
			if (breadcrumbs.length > 0) {
				const breadcrumbsHeight = breadcrumbs.innerHeight();

				let totalHeight = +breadcrumbsHeight + +topnavHeight;

				$("section")
					.eq(0)
					.css("margin-top", "-" + totalHeight + "px");
				$("section")
					.eq(0)
					.css("padding-top", totalHeight + "px");
			} else {
				$("section")
					.eq(0)
					.css("margin-top", "-" + topnavHeight + "px");
			}
		} else {
			$("section").eq(0).css("margin-top", "0");
			$("section").eq(0).css("padding-top", "0");
		}
		$(window).resize(function () {
			if ($(window).width() > 1200) {
				const topnavHeight = topnav.innerHeight();
				const breadcrumbs = $(".breadcrumbs");
				if (breadcrumbs.length > 0) {
					const breadcrumbsHeight = breadcrumbs.innerHeight();

					let totalHeight = +breadcrumbsHeight + +topnavHeight;

					$("section")
						.eq(0)
						.css("margin-top", "-" + totalHeight + "px");
					$("section")
						.eq(0)
						.css("padding-top", totalHeight + "px");
				} else {
					$("section")
						.eq(0)
						.css("margin-top", "-" + topnavHeight + "px");
				}
			} else {
				$("section").eq(0).css("margin-top", "0");
				$("section").eq(0).css("padding-top", "0");
			}
		});
	}
	setMarginToFirstSection();

	// hero slider
	$(".hero-slider")
		.on("init", function () {
			const topnav = $(".top-nav");

			topnav.addClass("top-nav--blur");
		})
		.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			fade: false,
			infinite: true,
			// autoplay: true,
			speed: 3000,
			nextArrow: `<button class="next"><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="50" y="50.0004" width="50" height="50" rx="25" transform="rotate(-180 50 50.0004)" fill="white" fill-opacity="0.3"/>
<path d="M19 38.0004L31 25.5559L19 13.1115" stroke="white" stroke-width="3"/>
</svg>
</button>`,
			prevArrow: `<button class="prev"><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="50" height="50" rx="25" fill="white" fill-opacity="0.3"/>
<path d="M31 13L19 25.4444L31 37.8889" stroke="white" stroke-width="3"/>
</svg>
</button>`,
		});

	$(".slider").each(function () {
		const slideCount = $(this).attr("data-slider-count");
		$(this).slick({
			slidesToShow: slideCount,
			slidesToScroll: 1,
			arrows: true,
			fade: false,
			infinite: true,
			// autoplay: true,
			speed: 1000,
			nextArrow: `<button class="next"><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="50" y="50.0004" width="50" height="50" rx="25" transform="rotate(-180 50 50.0004)" fill="white" fill-opacity="0.3"/>
			<path d="M19 38.0004L31 25.5559L19 13.1115" stroke="white" stroke-width="3"/>
			</svg>
			</button>`,
			prevArrow: `<button class="prev"><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="50" height="50" rx="25" fill="white" fill-opacity="0.3"/>
			<path d="M31 13L19 25.4444L31 37.8889" stroke="white" stroke-width="3"/>
			</svg>
			</button>`,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				},

				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});
	});

	function anchorScroll() {
		$(".anchor").on("click", function (e) {
			e.preventDefault();
			var id = $(this).attr("href");
			$("html, body").animate(
				{
					scrollTop: $(id).offset().top,
				},
				"smooth"
			);
		});
	}
	anchorScroll();

	// Input mask
	$("input[type=tel]").inputmask("+7(999)-999-99-99");

	function AOSAnimation() {
		$(".section-title").attr("data-aos", "fade-right");
		$(".card").attr("data-aos", "zoom-in");
		if ($(window).width() > 992  )  {
			$(".decor-item").attr("data-aos", "zoom-in-up");
		$(".decor-item").attr("data-aos-duration", "1200");
		}
		
		

		setTimeout(function () {
			AOS.init({
				once: true,
			});
		}, 200);
	}
	AOSAnimation();
});
